module.exports = __webpack_public_path__ + "static/media/project-summary-list.b2c23e60.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/project-summary-list.scss
// module id = 2295
// module chunks = 0